"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewPositionControls = void 0;
const UiElements_1 = require("../../ui/UiElements");
class ViewPositionControls {
    constructor(parentEl) {
        if (!parentEl) {
            throw new Error("Parent element (viewPosition) is undefined");
        }
        const title = this.createTitle();
        const element = this.createElement();
        parentEl.append(title.domEl, element.domEl);
    }
    dispose() {
        delete this.leftBtn;
        delete this.rightBtn;
        delete this.topBtn;
        delete this.bottomBtn;
        delete this.frontBtn;
        delete this.backBtn;
        delete this.centerBtn;
    }
    createTitle() {
        return new UiElements_1.DivEl()
            .setClass('module-title')
            .setId('viewPositionTitle')
            .addAttribute('data-i18n-key', 'NAVIGATION');
    }
    createElement() {
        this.bottomBtn = this.createButton('BOTTOM', 'bottom');
        this.leftBtn = this.createButton('LEFT', 'left');
        this.rightBtn = this.createButton('RIGHT', 'right');
        this.topBtn = this.createButton('TOP', 'top');
        this.frontBtn = this.createButton('FRONT', 'front');
        this.backBtn = this.createButton('BACK', 'back');
        this.centerBtn = this.createButton('CENTER', 'center');
        return new UiElements_1.DivEl()
            .setId('viewPositionControls')
            .setClass('controls')
            .addChild(this.leftBtn)
            .addChild(this.rightBtn)
            .addChild(this.topBtn)
            .addChild(this.bottomBtn)
            .addChild(this.frontBtn)
            .addChild(this.backBtn)
            .addChild(this.centerBtn);
    }
    createButton(tooltip, icon) {
        return new UiElements_1.ButtonEl()
            .addAttribute('data-i18n-attr', `data-title=${tooltip}`)
            .addChild(new UiElements_1.IconEl(icon));
    }
}
exports.ViewPositionControls = ViewPositionControls;
